import { createStore } from 'redux';

const initialState = {
  // initial state here
};

function reducer(state = initialState, action) {
  switch (action.type) {
    default:
      return state;
  }
}

const store = createStore(reducer);

export default store;
